import React, { useState, useEffect } from 'react';
import {View, StyleSheet, LayoutChangeEvent} from 'react-native';
import * as RNP from 'react-native-progress'
import { useTheme } from '@shopify/restyle';
import { Theme } from '@app/theme';

export type ProgressBarComponentType = {
    color?: string,
    unfilledColor?: string,
    height?: number,
    width?: number,
    loadingTime?: number,
    indeterminate?: boolean
}

const ProgressBar: React.FC<ProgressBarComponentType> = ({
    color,
    unfilledColor,
    height,
    width,
    loadingTime,
    indeterminate
}) => {
    const [progress, setProgress] = useState(0);
    const [progressBarWidth, setProgressBarWidth] = useState(width ? width : 200);

    const {colors} = useTheme<Theme>()

    const animationDuration = loadingTime ? loadingTime : 3000; // 3 seconds
    const interval = 50; // Update every 50 milliseconds

    useEffect(() => {
        const steps = animationDuration / interval;
        const increment = 1 / steps;

        const progressInterval = setInterval(() => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + increment;
                return newProgress >= 1 ? 1 : newProgress;
            });
        }, interval);

        return () => clearInterval(progressInterval); // Cleanup the interval on component unmount
    }, []);

    return (
        <View style={styles.container} onLayout={(event: LayoutChangeEvent)=>{
                event?.nativeEvent?.layout?.width &&
                setProgressBarWidth(width ? width : event?.nativeEvent?.layout?.width)
        }}>
            <RNP.Bar
                width={progressBarWidth}
                useNativeDriver={true}
                color={color ? color : colors['bg-action-primary']}
                unfilledColor={unfilledColor? unfilledColor : colors['white']}
                height={height ? height : 40}
                indeterminate={indeterminate ? indeterminate : false}
                progress={progress}
                animated={true}
                borderWidth={0}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
});

export default ProgressBar;
